
import { Options, Vue } from 'vue-class-component';
import Top from './components/Top.vue';

@Options({
  components: {
    Top,
  },
})
export default class App extends Vue {}
